// START_MODULE components_atoms_link_link_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import { Link as RouterLink } from 'react-router-dom';
import styled, { css, DefaultTheme } from 'styled-components';

interface LinkProps {
  $underline?: boolean;
}

export const LinkRouter = styled(RouterLink)<LinkProps>`
  ${({ theme, $underline = true }) => getCommonStyles(theme, $underline)};
`;

export const Link = styled.a<LinkProps>`
  ${({ theme, $underline = true }) => getCommonStyles(theme, $underline)};
`;

const getCommonStyles = (theme: DefaultTheme, underline: boolean) => css`
  text-decoration: none;
  font-weight: 700;
  vertical-align: top;
  color: black;

  position: relative;
  transition: color .3s ease-in-out;

  display: flex;
  align-items: center;
  gap: 2px;

  ${underline && css`
    &::before {
      content: '';
      position: absolute;
      top: 100%;
      display: block;
      width: 100%;
      height: 3px;
      background-color: ${theme.accentColor};
      transform: scaleX(0);
      transition: transform .3s ease-in-out;
    }
    &:hover::before {
      transform: scaleX(1);
    }
  `};

  &:hover {
    color: ${theme.accentColor};
  }
`;

export default Link;

// END_MODULE components_atoms_link_link_tsx
